import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getSettingChatWorkingHours } from "@faire/help-center-utils/settings/getSettingChatWorkingHours";
import { getSettingPhoneWorkingHours } from "@faire/help-center-utils/settings/getSettingPhoneWorkingHours";
import addDays from "date-fns/addDays";
import formatDuration from "date-fns/formatDuration";
import intervalToDuration from "date-fns/intervalToDuration";
import isWeekend from "date-fns/isWeekend";
import set from "date-fns/set";
export var convertDateToTargetTimeZoneDate = function convertDateToTargetTimeZoneDate(date, targetTimeZone) {
  var convertedDate = date.toLocaleString("en-US", {
    timeZone: targetTimeZone,
    hour12: false
  });
  return convertedDate;
};
export var convertDateHoursInMilliseconds = function convertDateHoursInMilliseconds(date) {
  var hoursInMilliseconds = new Date(date).getHours() * 60 * 60 * 1000;
  return hoursInMilliseconds;
};
export var isWeekendFromDate = function isWeekendFromDate(date) {
  return isWeekend(new Date(date));
};
export var availableInHoursMinutesOrDays = function availableInHoursMinutesOrDays(supportType) {
  var _targetDate$split$, _targetDate$split$$sp;
  var workingHoursSetting;
  if (supportType === "chat") {
    workingHoursSetting = getSettingChatWorkingHours();
  } else {
    workingHoursSetting = getSettingPhoneWorkingHours();
  }
  var _workingHoursSetting = workingHoursSetting,
    start_at = _workingHoursSetting.start_at,
    end_at = _workingHoursSetting.end_at,
    timezone = _workingHoursSetting.timezone;
  if (!start_at || !end_at) {
    return {
      time: "",
      unit: undefined
    };
  }
  var currentDate = new Date();
  var tomorrowDate;
  var targetDate = convertDateToTargetTimeZoneDate(currentDate, timezone !== null && timezone !== void 0 ? timezone : "America/New_York");
  var hours = (_targetDate$split$ = targetDate.split(":")[0]) === null || _targetDate$split$ === void 0 ? void 0 : (_targetDate$split$$sp = _targetDate$split$.split(",")[1]) === null || _targetDate$split$$sp === void 0 ? void 0 : _targetDate$split$$sp.trim();
  if (Number(hours) >= end_at / (60 * 60 * 1000)) {
    tomorrowDate = addDays(new Date(targetDate), 1);
  } else {
    tomorrowDate = new Date(targetDate);
  }
  var tomorrowAvailableDate = set(tomorrowDate, {
    hours: start_at / (60 * 60 * 1000),
    minutes: 0,
    seconds: 0,
    milliseconds: 0
  });
  // Check if today is a weekend
  var dayOfWeek = new Date(targetDate).getDay();
  if (dayOfWeek === 0 || dayOfWeek === 6) {
    // 0 = Sunday, 6 = Saturday
    var daysUntilMonday = dayOfWeek === 0 ? 1 : 2;
    return {
      time: String(daysUntilMonday),
      unit: "days"
    };
  }
  var duration = intervalToDuration({
    start: new Date(targetDate),
    end: tomorrowAvailableDate
  });
  // The difference hours between current time and tomorrow's start time needs to minus 1
  if (duration.hours && duration.hours > 1) {
    if (duration.minutes === 0) {
      duration = _objectSpread(_objectSpread({}, duration), {}, {
        hours: duration.hours
      });
    } else {
      duration = _objectSpread(_objectSpread({}, duration), {}, {
        hours: duration.hours + 1
      });
    }
  }
  var isLessThanOneHour = !!(duration.hours === 0 && duration.minutes && duration.minutes < 60);
  var formattedDuration = formatDuration(duration, {
    format: isLessThanOneHour ? ["minutes"] : ["hours"]
  });
  var _formattedDuration$sp = formattedDuration.split(" "),
    _formattedDuration$sp2 = _slicedToArray(_formattedDuration$sp, 2),
    time = _formattedDuration$sp2[0],
    unit = _formattedDuration$sp2[1];
  if (isLessThanOneHour) {
    if (duration.seconds && duration.seconds !== 0) {
      return {
        time: String(Number(time) + 1),
        unit: "minutes"
      };
    }
  }
  return {
    time: time,
    unit: unit === "hours" || unit === "hour" ? "hours" : "minutes"
  };
};